import React from 'react';
import '../styles/custom.css';

interface LayoutProps {
    children: React.ReactNode;
    isWelcomePage?: boolean;
    onContactUs?: () => void;
    onClose?: () => void;
}

const Layout: React.FC<LayoutProps> = ({ 
    children, 
    isWelcomePage = false, 
    onContactUs, 
    onClose
}) => (
    <div className="welcome-container">
        {/* Header: Welcome page shows Contact Us and Close, ProviderSearch shows Home */}
        <header className="welcome-header">
            <img src={`${process.env.PUBLIC_URL}/coventry-logo.png`} alt="Coventry Logo" className="coventry-logo" />
            <div className="header-links">
                {isWelcomePage ? (
                    <>
                        <button
                            className="contact-link"
                            style={{background:'none',border:'none',padding:0,cursor:'pointer'}}
                            onClick={(e: React.MouseEvent<HTMLButtonElement>) => { 
                                e.preventDefault(); 
                                onContactUs && onContactUs(); 
                            }}
                        >
                            Contact Us
                        </button>
                        <span className="header-separator">|</span>
                        <span 
                            className="close-link"
                            onClick={onClose}
                            style={{ cursor: 'pointer' }}
                        >
                            Close
                        </span>
                    </>
                ) : (
               <a href="." className="contact-link">Home</a>
                )}
            </div>
        </header>

        {/* Main Content */}
        <main>
            {children}
        </main>

        {/* Footer */}
        <footer className="welcome-footer">
            <div className="footer-content">
                <div className="footer-links">
                    <a
                        href="https://www.enlyte.com/terms-use"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="footer-link"
                    >
                        Terms and Conditions
                    </a>
                    <span className="footer-separator">|</span>
                    <a
                        href="https://www.enlyte.com/privacy"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="footer-link"
                    >
                        Privacy Policy
                    </a>
                </div>
                <div className="footer-copyright">
                    &copy; {new Date().getFullYear()} Enlyte Group, LLC. All rights reserved.
                </div>
            </div>
        </footer>
    </div>
);

export default Layout;